import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_edit_member",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "modal-dialog modal-lg"
}
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "row mb-3" }
const _hoisted_10 = { class: "col-md-6 mb-2" }
const _hoisted_11 = { class: "col-md-6 mb-2" }
const _hoisted_12 = { class: "row mb-4" }
const _hoisted_13 = {
  key: 0,
  class: "col-md-12 mb-3"
}
const _hoisted_14 = { class: "form-group mr-b-0em" }
const _hoisted_15 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6 mb-3" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mr-b-0em" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group mr-b-0em" }
const _hoisted_26 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = { class: "col-md-12" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = { class: "col-md-6 text-right" }
const _hoisted_45 = { class: "col-md-6 text-right" }
const _hoisted_46 = {
  type: "submit",
  class: "w-100 btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_DynamicToggle = _resolveComponent("DynamicToggle")!
  const _component_radioInput = _resolveComponent("radioInput")!
  const _component_input_image = _resolveComponent("input-image")!
  const _component_capture_photo = _resolveComponent("capture-photo")!
  const _component_inputText = _resolveComponent("inputText")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_phone_number = _resolveComponent("phone-number")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_inputTextarea = _resolveComponent("inputTextarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.requestMember)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.isRequestMember)
              ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('layout.navbar.modal.edit_member.title')), 1),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_edit_member', 'edit'))),
                type: "button",
                class: "btn-close",
                "aria-label": "btn-close"
              })
            ]),
            (_ctx.requestMember)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("form", {
                    class: "forms-sample",
                    onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_DynamicToggle, {
                          text: _ctx.i18n.t('tables.members.sync_image_to_pointeuse'),
                          modelValue: _ctx.requestMember.sync_image_to_pointeuse,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestMember.sync_image_to_pointeuse) = $event)),
                          name: "sync_image_to_pointeuse",
                          id: "sync_image_to_pointeuse"
                        }, null, 8, ["text", "modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_radioInput, {
                          modelValue: _ctx.isCaputre,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isCaputre) = $event)),
                          valueAttr: 1,
                          label: _ctx.i18n.t('button.upload_image'),
                          name: `isCaputre`,
                          id: `isCaputre-1`
                        }, null, 8, ["modelValue", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_radioInput, {
                          modelValue: _ctx.isCaputre,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isCaputre) = $event)),
                          valueAttr: 0,
                          label: _ctx.i18n.t('button.take_photo'),
                          name: `isCaputre`,
                          id: `isCaputre-0`
                        }, null, 8, ["modelValue", "label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (_ctx.isCaputre)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_input_image, {
                                modelValue: _ctx.requestMember.path_image,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestMember.path_image) = $event)),
                                label: _ctx.i18n.t('tables.members.name'),
                                pathImage: _ctx.requestMember.path_image,
                                disabled: false
                              }, null, 8, ["modelValue", "label", "pathImage"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.isCaputre)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_capture_photo, {
                              modelValue: _ctx.requestMember.path_image,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestMember.path_image) = $event)),
                              pathImage: _ctx.requestMember.path_image,
                              v: _ctx.v$.path_image
                            }, null, 8, ["modelValue", "pathImage", "v"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestMember.matricule,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestMember.matricule) = $event)),
                            label: _ctx.i18n.t('tables.members.matricule'),
                            v: _ctx.v$.matricule,
                            disabled: true
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestMember.contractNumber,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestMember.contractNumber) = $event)),
                            label: _ctx.i18n.t('tables.members.contractNumber'),
                            v: _ctx.v$.contractNumber,
                            disabled: true
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_SingleSelect, {
                          TextLabel: _ctx.i18n.t('tables.members.seller'),
                          trackby: `id`,
                          label: `name`,
                          valueProp: `id`,
                          modelValue: _ctx.requestMember.seller_id,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestMember.seller_id) = $event)),
                          placeholder: _ctx.i18n.t('tables.members.seller'),
                          arrayOptions: _ctx.employeesSellersList,
                          refs: "sellers",
                          v: _ctx.v$.seller_id
                        }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_SingleSelect, {
                            TextLabel: _ctx.i18n.t('tables.members.age_category'),
                            trackby: `id`,
                            label: `name`,
                            valueProp: `id`,
                            modelValue: _ctx.requestMember.age_category,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestMember.age_category) = $event)),
                            placeholder: _ctx.i18n.t('tables.members.age_category'),
                            arrayOptions: _ctx.targetAgeList,
                            refs: "age_category",
                            v: _ctx.v$.age_category
                          }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_SingleSelect, {
                            TextLabel: _ctx.i18n.t('tables.members.gender'),
                            trackby: `id`,
                            label: `name`,
                            valueProp: `id`,
                            modelValue: _ctx.requestMember.gender,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestMember.gender) = $event)),
                            placeholder: _ctx.i18n.t('tables.members.gender'),
                            arrayOptions: _ctx.filteredGenders,
                            refs: "gender",
                            v: _ctx.v$.gender
                          }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                        ])
                      ]),
                      (_ctx.requestMember.age_category == 'minor' || _ctx.requestMember.gender == 2 || _ctx.requestMember.gender == 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_inputText, {
                                modelValue: _ctx.requestMember.parent_name,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestMember.parent_name) = $event)),
                                label: _ctx.i18n.t('tables.members.parent_name'),
                                v: _ctx.v$.parent_name,
                                disabled: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestMember.name,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.requestMember.name) = $event)),
                            label: _ctx.i18n.t('tables.members.name'),
                            v: _ctx.v$.name,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestMember.email,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.requestMember.email) = $event)),
                            label: _ctx.i18n.t('tables.members.email'),
                            v: _ctx.v$.email,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_phone_number, {
                            modelValue: _ctx.requestMember.tele,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requestMember.tele) = $event)),
                            label: _ctx.i18n.t('tables.members.tele'),
                            v: _ctx.v$.tele,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestMember.cin,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.requestMember.cin) = $event)),
                            label: _ctx.i18n.t('tables.members.cin'),
                            v: _ctx.v$.cin,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_date_field, {
                            modelValue: _ctx.requestMember.dateBirth,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.requestMember.dateBirth) = $event)),
                            label: _ctx.i18n.t('tables.members.dateBirth'),
                            v: _ctx.v$.dateBirth,
                            fixedDays: 1,
                            isFixedDays: true
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestMember.occupation,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.requestMember.occupation) = $event)),
                            label: _ctx.i18n.t('tables.members.occupation'),
                            v: _ctx.v$.occupation,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_inputTextarea, {
                            modelValue: _ctx.requestMember.adresse,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.requestMember.adresse) = $event)),
                            label: _ctx.i18n.t('tables.members.adresse'),
                            v: _ctx.v$.adresse,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_inputTextarea, {
                            modelValue: _ctx.requestMember.comment,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.requestMember.comment) = $event)),
                            label: _ctx.i18n.t('tables.members.comment'),
                            v: _ctx.v$.comment,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.closeModal('modal_edit_member', 'edit'))),
                          class: "w-100 btn btn-cancel"
                        }, _toDisplayString(_ctx.i18n.t('button.close')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("button", _hoisted_46, _toDisplayString(_ctx.i18n.t('button.edit')), 1)
                      ])
                    ])
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}